import {createContext, useState} from 'react'
import api from '../service/api'

export const AuthContext = createContext();

export function AuthProvider({children}){
  const [data, setData] = useState(() => {
    const token = localStorage.getItem("@robertoapp: token")
    if(token){
      return {token}
    }
    else{
      return {}
    }
  })
  async function login({email, password}){
    try{
      const response = await api.post("/auth/login", {email, password});
      const {token} = response.data.data;
      localStorage.setItem("@robertoapp: token", token)
      setData({token: token})
    }catch(err){
      alert("Credenciais Inválidas")
    }
  }
  async function logout(){
    try{   
      localStorage.removeItem("@robertoapp: token")
      setData({})
    }catch(err){
      alert("problema no logout")
    }
  }

  return(
    <AuthContext.Provider value = {{token: data.token, login, logout}} >
      {children}
    </AuthContext.Provider>
  )
};
